import { checkPermission } from '@/router/guards.ts'

const ServiceModule = () => import('./ServiceModule.vue')
const ServiceIndex = () => import('./views/ServiceIndex.vue')

export const serviceRoute = {
  path: '/services',
  name: 'service',
  component: ServiceModule,
  meta: {
    title: 'Services',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'services-index',
      component: ServiceIndex,
      meta: {
        permission: 'service.view',
      },
      beforeEnter: checkPermission('service.view'),
    },
  ],
}
